import { markRaw } from 'vue';

function install(app) {
    app.config.globalProperties.mCache = markRaw([]);
}

export default install;
